// src/utils/helpers.js
export const xpForLevel  = lvl  => (lvl - 1) * 500;
export const xpToNext    = lvl  => lvl * 500;
export const levelFromXP = xp   => Math.floor(xp / 500) + 1;
export const xpProgress  = (xp, lvl) => {
  const base = xpForLevel(lvl), next = xpToNext(lvl);
  return Math.min(Math.max(((xp - base) / (next - base)) * 100, 0), 100);
};
export const trackColor = t => ({ html:'#ff6432', css:'#3296ff', javascript:'#ffd700' }[t] || '#00f5ff');
export const trackIcon  = t => ({ html:'🌐', css:'🎨', javascript:'⚡' }[t] || '💻');
export const escapeHtml = s => s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
export const canClaimDaily = last => {
  if (!last) return true;
  return new Date(last).toDateString() !== new Date().toDateString();
};
